import { Component } from '@angular/core';
import { ClientService } from '../../core/services/client.service';

@Component({
  selector: 'app-mfa-banner',
  templateUrl: './mfa-banner.component.html',
  styleUrl: './mfa-banner.component.scss'
})
export class MfaBannerComponent {
  mfaReminderSupressed = false;

  constructor(private clientService: ClientService) {
    clientService.getMfaReminderSupressed().subscribe(val => this.mfaReminderSupressed = val);
  }

  supressMfaReminder() {
    this.clientService.supressMfaReminder();
  }
}
